import { render, staticRenderFns } from "./CompanyUsers.vue?vue&type=template&id=c06edd14&scoped=true"
import script from "./CompanyUsers.vue?vue&type=script&lang=js"
export * from "./CompanyUsers.vue?vue&type=script&lang=js"
import style0 from "./CompanyUsers.vue?vue&type=style&index=0&id=c06edd14&prod&lang=scss"
import style1 from "./CompanyUsers.vue?vue&type=style&index=1&id=c06edd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06edd14",
  null
  
)

export default component.exports